import React, {Component} from 'react';
import {Row, Alert, Table, Button, Col} from 'antd';

class PreparationOut extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const columns1 = [
                {
                    title: '序号',
                    dataIndex: 'xh',
                    key: 'xh',
                    width: '5%',
                    render(text, record, index){
                        return index+1;
                    }
                },
                {
                    title: '任务地点',
                    dataIndex: 'rwdd',
                    key: 'rwdd',
                    width: '30%'
                },
                {
                    title: '任务主要内容',
                    dataIndex: 'rwzynr',
                    key: 'rwzynr',
                    width: '30%'
                },
                {
                    title: '立案时间',
                    dataIndex: 'lasj',
                    key: 'lasj',
                    width: '10%'
                },
                {
                    title: '危险程度',
                    dataIndex: 'wxcd',
                    key: 'wxcd',
                    width: '10%'
                },
                {
                    title: '操作',
                    dataIndex: 'cz',
                    key: 'cz',
                    width: '15%',
                    render: (text, record) => {
                        return (
                            <Row type="flex" justify="center">
                                <Button type="primary" style={{marginRight: 10}} size="small">报备</Button>
                                <Button size="small" style={{marginLeft: 10}}>不参与</Button>
                            </Row>
                        )
                    }
                },
            ],
            columns2 = [
                {
                    title: '序号',
                    dataIndex: 'xh',
                    key: 'xh',
                    width: '5%',
                    render(text, record, index){
                        return index+1;
                    }
                },
                {
                    title: '任务地点',
                    dataIndex: 'rwdd',
                    key: 'rwdd',
                    width: '20%'
                },
                {
                    title: '任务主要内容',
                    dataIndex: 'rwzynr',
                    key: 'rwzynr',
                    width: '20%'
                },
                {
                    title: '目前人數/最多限制人數',
                    dataIndex: 'mqrs',
                    key: 'mqrs',
                    width: '20%'
                },
                {
                    title: '立案时间',
                    dataIndex: 'lasj',
                    key: 'lasj',
                    width: '10%'
                },
                {
                    title: '危险程度',
                    dataIndex: 'wxcd',
                    key: 'wxcd',
                    width: '10%'
                },
                {
                    title: '操作',
                    dataIndex: 'cz',
                    key: 'cz',
                    width: '15%',
                    render: (text, record) => {
                        return (
                            <Row type="flex" justify="center">
                                <Button type="primary" style={{marginRight: 10}} size="small">报备</Button>
                                <Button size="small" style={{marginLeft: 10}}>不参与</Button>
                            </Row>
                        )
                    }
                },
            ],
            loading = this.state.data_loding,
            locale = {
                filterTitle: '筛选',
                filterConfirm: '确定',
                filterReset: '重置',
                emptyText: loading ? '正在加载中...' : '暂无报备信息',
            },
            dataSource = [
                {
                    rwdd: '1',
                    rwzynr: '1',
                    lasj: '1',
                    wxcd: '1'
                }, {
                    rwdd: '1',
                    rwzynr: '1',
                    lasj: '1',
                    wxcd: '1'
                }, {
                    rwdd: '1',
                    rwzynr: '1',
                    lasj: '1',
                    wxcd: '1'
                }, {
                    rwdd: '1',
                    rwzynr: '1',
                    lasj: '1',
                    wxcd: '1'
                }, {
                    rwdd: '1',
                    rwzynr: '1',
                    lasj: '1',
                    wxcd: '1'
                }, {
                    rwdd: '1',
                    rwzynr: '1',
                    lasj: '1',
                    wxcd: '1'
                }, {
                    rwdd: '1',
                    rwzynr: '1',
                    lasj: '1',
                    wxcd: '1'
                }, {
                    rwdd: '1',
                    rwzynr: '1',
                    lasj: '1',
                    wxcd: '1'
                }, {
                    rwdd: '1',
                    rwzynr: '1',
                    lasj: '1',
                    wxcd: '1'
                }, {
                    rwdd: '1',
                    rwzynr: '1',
                    lasj: '1',
                    wxcd: '1'
                }, {
                    rwdd: '1',
                    rwzynr: '1',
                    lasj: '1',
                    wxcd: '1'
                }
            ];
        return (
            <div className="report-out">
                <div className="page-title">出队报备<span>Report out</span></div>
                <Alert message={<span>每人只可以接一单案, 任务期间不会出现新的案件通知, 完成之后可以重新接案；<br/>队伍管理员或省级管理员只能发布一单案件给队员；<br/>在队员进行任务期间可以特别委派一单紧急任务；</span>}
                       type="warning" showIcon/>
                <div className="page-content">
                    <Table columns={columns1} locale={locale} className="top-table" dataSource={dataSource} scroll={{y: 'calc(100% - 38px)'}} pagination={false}
                           size="small" title={() => <div className="table-title">上级指定任务<span>(请在5分钟内确认是否参与救援行动)</span></div>}/>
                    <Table columns={columns2} locale={locale} className="bottom-table" dataSource={dataSource} scroll={{y: 'calc(100% - 38px)'}} pagination={false}
                           size="small" title={() => <div className="table-title">队伍任务<span>(请在5分钟内确认是否参与救援行动)</span></div>}/>
                </div>
            </div>
        );
    }
}

export default PreparationOut;



// WEBPACK FOOTER //
// ./src/routes/task/PreparationOut.jsx